/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_BuyerInputs */

const cs_enum_buyer = /** @type {(inputs: Enum_BuyerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kupec`)
};

const en_enum_buyer = /** @type {(inputs: Enum_BuyerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buyer`)
};

/**
* | output |
* | --- |
* | "Buyer" |
*
* @param {Enum_BuyerInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_buyer = /** @type {((inputs?: Enum_BuyerInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_BuyerInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_buyer(inputs)
	return cs_enum_buyer(inputs)
});